import lang from 'dojo/_base/lang';
import { compose, mdsWidget, mdsLazyProto } from 'dojo/_base/declare';
import GenericDialog from '../GenericDialog/GenericDialog';
import { TabbingHelpers, TranslationHelpers } from "../../../more/Helpers";
import { EntityViewTypes } from "../EntityBased/EntityView/EntityViewTypes";
import { GenericDialogTypes } from "../GenericDialog/GenericDialogTypes";
import { uiFrameTypes } from "./uiFrameTypes";
import { ExpandableSection } from "./ExpandableSectionTypes";
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import TabContainer from '../Tabbing/TabContainer';
import FloatingMenu from '../Floating/Menu';
import Button from '../Button/Button';
import FloatingContainer from '../Floating/FloatingContainer';

//import GenericEntityView = require("./GenericEntityView"); // das geht ned. zirkuläre Abhängigkeit!

/**
 * Mixin, das Schnittstellen und Methoden zur Einbettung in Tabcontainer, GenericDialog oder freiplatzierte Elemente bereitstellt.
 * Ein von _uiFrameMixin abgeleitetes Widget kann
 * - sich in einem Dialog oder als Tab öffnen
 * - direkt in eine Ziel-Node platziert werden
 * - Buttons hinzufügen, die je nach Einbettungsart standardisiert an vorgesehenen Stellen aufscheinen
 * - sich beim Schließen mit einem closed-Event melden
 * - sich bei Updates mit einem updated-Event melden etc.
 */
type _uiFrameMixin__mdsbase = InstanceType<typeof _WidgetBaseSP>;
interface _uiFrameMixin extends _uiFrameMixin__mdsbase { }
export default function _uiFrameMixin(__Base: any) {
  const __C = 
class _uiFrameMixin extends __Base {

    protected heading: HTMLElement;
    protected buttonContainerPrimary: HTMLElement;
    protected buttonContainerSecondary: HTMLElement;
    private __secondaryButtonMenu: MdsLax<InstanceType<typeof Button>>;
    private __secondaryButtonFloatingMenu: MdsLax<InstanceType<typeof FloatingMenu>>;

    protected iconclass: string;
    protected showInSidebar: boolean;

    protected _uiFrameDlg: MdsLax<InstanceType<typeof GenericDialog>>;
    protected _tabContainer: MdsLax<InstanceType<typeof TabContainer>>;

    protected isEmbeddedInTab: boolean; // bissl redundant...
    protected _uiFrameIsStandalone: boolean; // ... die Info erkennt man an und für sich am currentDisplayMode
    protected useStandaloneFrame: boolean;

    protected _uiFrameExpandableSection: MdsLax<InstanceType<typeof ExpandableSection>>;

    protected _uiFrameFloatingContainer: MdsLax<InstanceType<typeof FloatingContainer>>;

    protected internalName: string;
    protected tabContainerName: string;

    protected isActive: boolean;

    protected currentDisplayMode: uiFrameTypes.DisplayMode;

    private __buttonConfigsQueue: Array<uiFrameTypes.ButtonConfig>;
    private __buttonConfigs: Array<uiFrameTypes.ButtonConfig>;
    private __buttonMenuConfigs: Array<uiFrameTypes.ButtonGroupConfig>;
    private __createdDefaultButtons: Array<uiFrameTypes.DefaultButtonName>;

    protected _isEmptyContent: boolean;
    private __hideIfEmpty: boolean;
    private __isHidden: boolean;
    private __hidingCallback: Function;

    //private contextButtons: Array<ContextButton> = [];


    private _onDlgClosed() {

    }
    // Tab-Mixin:
    _onClosing() {
        let self: any = this;
        super._onClosing.apply(this, arguments as any);

        this.close();
    }
    private _onDlgResult(result: number) {

        if (result <= 0) {
            this.close();
        }

        if (result >= 1) // yes, ok, save, etc...
        {

        }
    }

    protected changeInternalName(newInternalName: string) {
        if (this._tabContainer && this.currentDisplayMode === "tab") {
            this._tabContainer.changePageName(this.internalName, newInternalName);
        } else {

        }
        this.internalName = newInternalName;
    }

    setDirtyMarker(isDirty: boolean) {


        switch (this.currentDisplayMode) {
            case "dlg":
                if (this._uiFrameDlg) this._uiFrameDlg._toggleHeaderClass("dirty", isDirty);
                break;
            case "node":
                if (this._uiFrame_Heading) this.UiModder.domClass.toggle(this._uiFrame_Heading, "dirty", isDirty);
                break;
            default:

                break;
        }
    }

    /**
     * Den Inhalt ausblenden, falls leer.
     * Rückgabe: true, wenn sich die View ausblendet.
     * Callback: Wird aufgerufen, sobald sich der Zustand ändert (Parameter: boolean)
     */
    hideIfEmpty(bHide?: boolean, isEmpty?: boolean, callback?: Function): boolean {
        if (bHide === true || bHide === false) this.__hideIfEmpty = bHide;

        if (isEmpty === true || isEmpty === false) this._isEmptyContent = isEmpty;

        let bOverrideResult: boolean = false;
        if (typeof (callback) != "undefined") {
            this.__hidingCallback = callback;
            bOverrideResult = !!callback; // wenns ein neues Callback gibt, dann unbedingt aufrufen.
        }

        callback = this.__hidingCallback;

        let bHideTarget = this._isEmptyContent && this.__hideIfEmpty;

        this.hideNode(this.domNode, bHideTarget);

        if (this.__isHidden != bHideTarget || bOverrideResult) {
            this.__isHidden = bHideTarget;
            if (callback) callback(bHideTarget);
        }

        return bHideTarget;
    }


    //private requestContextButton(config: Tabbing.ContextActionButtonRequest) {
    //    if (this._uiFrameIsStandalone) {
    //        this.addButton(config.name,
    //            config.label,
    //            config.callback,
    //            config.tooltip,
    //            config.styleClass,
    //            config.iconClass,
    //            false,
    //            config.placement == "actionbar" ? "primary" : "secondary",
    //            config.enabled,
    //            config.order);
    //    } else if (this.isEmbeddedInTab) {
    //        //let self: any = this;
    //        //self.inherited(arguments);
    //        // inherited geht nicht weiter, wenn uiFrame selber nur von widgetBase abgeleitet ist!
    //        // wen
    //        this.emit("requestNewContextButton", config);
    //    } else if (this.currentDisplayMode == "dlg") {
    //        this.addButton(config.name,
    //            config.label,
    //            config.callback,
    //            config.tooltip,
    //            config.styleClass,
    //            config.iconClass,
    //            false,
    //            config.placement == "actionbar" ? "primary" : "secondary",
    //            config.enabled,
    //            config.order);
    //    }
    //}
    requestContextButtonRemove(name: string): void {
        this.removeButton(name);
    //    if (this._uiFrameIsStandalone) {
    //        this.removeButton(name);
    //    } else if (this._uiFrameDlg && !this._uiFrameDlg._destroyed) {
    //        this._uiFrameDlg.removeButton(name);
    //    } else if (this.isEmbeddedInTab && this._tabContainer) {
    //        this._tabContainer.removeButton(name, this.tabContainerName);
    //    }
    }
    //requestContextButtonEnable(name: string, bEnable?: boolean):void {
    //    if (this.isStandalone) {
    //        this.enableButton(name, bEnable);
    //    } else {
    //        let self: any = this;
    //        self.inherited(arguments);
    //    }
    //}
    requestContextButtonDisable(name: string, bDisable?: boolean): void {
        if (this.enableButton(name, bDisable !== true) == true) {
        }
          //if (this._uiFrameIsStandalone) {
          //    this.enableButton(name, bDisable !== true);
          //} else if (this._uiFrameDlg && !this._uiFrameDlg._destroyed) {
          //    this._uiFrameDlg.enableButton(name, !bDisable);
          //} else if (this._tabContainer) {
          //    this._tabContainer.disableButton(name, null, bDisable);
          //}
          else {
            let self: any = this;
            super.requestContextButtonDisable.apply(this, arguments as any);
        }
    }


    /**
     * LEGACY. Nicht mehr verwenden!
     * @param any Modus
     * @param any2 Titel
     * @param any3 tabcontainer-Name bei dlg- und tab-Variante
     * @param any4 Targetnode bei node-Variante
     * @deprecated
     */
    show(displaymode: "node", title: string, unused, targetNnode: HTMLElement) // LEGACY...
    /**
     * LEGACY. Nicht mehr verwenden!
     * @param any Modus
     * @param any2 Titel
     * @param any3 tabcontainer-Name bei dlg- und tab-Variante
     * @param any4 Targetnode bei node-Variante
     * @deprecated
     */
    show(displaymode, title: string, unused, targetNnode) // LEGACY...

    /**
     * Platzierung in einer Parentnode.
     * @param displaymode
     * @param targetnode
     * @param title
     */
    show(displaymode: "floatingContainer", placeAtNode: HTMLElement)

    /**
     * Platzierung in einer Parentnode.
     * @param displaymode
     * @param targetnode
     * @param title
     */
    show(displaymode: "node", placeAtNode: HTMLElement, title?: string)
    /**
     * Anzeige als Dialog.
     * @param displaymode
     * @param title
     * @param tabContainerName
     */
    show(displaymode: "dlg" | "largerDlg" | "smallerDlg" | "fullScreenDlg" | "largestDlg" | "contentBasedDlg", title?: string, tabContainerName?: string)
    /**
     * Anzeige als neuer Tab in einem Tabcontainer.
     * @param displaymode
     * @param title
     * @param tabContainerName
     */
    show(displaymode: "tab", title: string, tabContainerName: string)
    /**
     * Anzeige als Expander mit Platzierung in einer Node.
     * @param displaymode
     * @param title
     * @param targetNode
     */
    show(displaymode: "expander", title: string, placeAtNode: HTMLElement, expanded?: boolean)
    /**
     * Flexiblere Aufrufvariante zum Durchreichen von Parametern.
     * @param displaymode Platzierung im DOM oder Anzeige als Expander, Dialog oder Tab wählbar.
     * @param titleOrNode Bei Anzeige als Node die Parentnode, ansonsten Titel/Überschrift
     * @param tabcontainerNameOrNode Bei Expander: Die Parent-Node, ansonsten optional Name eines Tabcontainers, um den Frame dorthin zu pinnen.
     */
    show(displaymode: uiFrameTypes.DisplayMode, titleOrNode?: string | HTMLElement, tabcontainerNameOrNode?: HTMLElement)
    show(displaymode: uiFrameTypes.DisplayMode = "dlg", titleOrNode?: string | HTMLElement, unknown?: any, unknown2?: any) {

        if (this._tabContainer && this.currentDisplayMode == "tab" && displaymode != "tab") {
            this._tabContainer.destroyPage(this.internalName);
        }
        let title: string;
        let targetNode: HTMLElement = null;

        // LEGACY-PARAMETER - nach Update 2025-12 nicht mehr in den eigentlichen Aufrufen
        if (unknown2 instanceof HTMLElement) {
            targetNode = unknown2;
        }

        if (typeof (titleOrNode) == "string") title = titleOrNode;
        else if (titleOrNode instanceof HTMLElement) {
            // bei node-Mode (ba-dum tss) kommt die node als Pflicht zuerst und unknown ist der optionale title
            targetNode = titleOrNode;
            if (typeof unknown == "string") title = unknown;
        }

        if (title) this.title = title;

        

        if (unknown instanceof HTMLElement) {
            targetNode = unknown;
        }

        this._uiFrameIsStandalone = false;

        if (this.tabContainerName && this.currentDisplayMode == "tab" && displaymode != "tab") {
            this.close();
            this.UiModder.domClass.remove(this.domNode, "tabbed w3-content");
        }

        if (this._uiFrameDlg && this.currentDisplayMode == "dlg" && displaymode != "dlg") {
            this._uiFrameDlg.close(-1, true);
            this._uiFrameDlg = null;
        }

        if (displaymode == "expander" && targetNode instanceof HTMLElement) {
            this._uiFrameExpandableSection = new ExpandableSection();
            //this.expandableSection.setup(this, title);
            this._uiFrameExpandableSection.setupAsReplacement(this.domNode, this.title);
            this._uiFrameExpandableSection.placeAt(targetNode);

            this._uiFrameExpandableSection.on("expand", lang.hitch(this, this._onExpandSection, true));
            this._uiFrameExpandableSection.on("collapse", lang.hitch(this, this._onExpandSection, false));

            if (unknown2 === true || unknown2 === false) {
                this._uiFrameExpandableSection.toggleExpand(unknown2);
            }

            this.isActive = true;
            this.currentDisplayMode = "expander";
            this._continueShow();
        }

        if (displaymode == "floatingContainer") {
            this.useStandaloneFrame = true;
            this._uiFrameIsStandalone = true;
            

            let targetElement = titleOrNode as HTMLElement;
            this._uiFrameFloatingContainer = new FloatingContainer();
            this._uiFrameFloatingContainer.open(targetElement, this.domNode, true);

            this.isActive = true;
            this.currentDisplayMode = "floatingContainer";
            this._continueShow();
        }

        if (displaymode == "tab") {
            let tabContainerName = unknown;
            if (tabContainerName) this.tabContainerName = tabContainerName;
            tabContainerName = this.tabContainerName;


            if (tabContainerName) {
                if (TabbingHelpers.activateTab(this.internalName, tabContainerName) == true) {
                    return;
                } else {
                    //this.embedAsTab(this.tabContainerName);
                    TabbingHelpers.createNewTabbedContent({

                        enableClosing: true,
                        label: this.title,
                        name: this.internalName,
                        widget: this,
                        coloration: null,
                        iconclass: this.iconclass,
                        groupLabel: this.title,
                        sidebarEntryName: this.internalName,
                        targetContainerName: this.tabContainerName
                    }, true, true);

                    this.isActive = true;

                    if (this.isEmbeddedInTab) {
                        this.UiModder.domClass.add(this.domNode, "tabbed w3-content");
                    }
                }
            }

            if (this.isEmbeddedInTab) {
                TabbingHelpers.requestTabSwitchGlobal(this.internalName);
                this.currentDisplayMode = "tab";
                this.isActive = true;

                // bestehende Buttons wieder übernehmen!

                this._continueShow();
            } else {
                displaymode = "dlg";
            }
        }

        let modificator: GenericDialogTypes.DialogSize = null;
        switch (displaymode) {
            case "smallerDlg":
                modificator = "smaller";
                displaymode = "dlg";
                break;
            case "largerDlg":
                modificator = "larger";
                displaymode = "dlg";
                break;
            case "largestDlg":
                modificator = "largest";
                displaymode = "dlg";
                break;
            case "fullScreenDlg":
                modificator = "fullsize";
                displaymode = "dlg";
                break;
            case "contentBasedDlg":
                modificator = "contentBased";
                displaymode = "dlg";
                break;
        }


        if (displaymode == "dlg") {
            let tabContainerName = unknown;

            if (!this._uiFrameDlg) {
                this._uiFrameDlg = new GenericDialog();

                this._uiFrameDlg.closeOnEscape = true;

                this._uiFrameDlg.on("closed", lang.hitch(this, this._onDlgClosed));
            }
            if (this._uiFrameDlg) {


                if (modificator) {
                    this._uiFrameDlg.setSize(modificator);
                }

                this._uiFrameDlg.show(
                    this,
                    this.title ? this.title : this.translate("General_Loading"),
                    null, null,
                    "close",
                    lang.hitch(this, this._onDlgResult)
                );

                if (tabContainerName) {
                    this.tabContainerName = tabContainerName;
                    this._uiFrameDlg.addButton("tab-" + this.internalName,
                        "",
                        lang.hitch(this, this._moveToTab),
                        null,
                        null,
                        "fas fa-external-link-alt",
                        false,
                        "top first",
                        true);
                }

                this.isActive = true;
                this.currentDisplayMode = "dlg";
                this._continueShow();
            }
        }

        if (displaymode == "node" && targetNode) {
            this._uiFrameIsStandalone = true;
            this.useStandaloneFrame = true; // TODO, das sollte noch steuerbar werden...

            if (this.domNode?.parentNode != targetNode) {
                this.placeAt(targetNode);

            }

            //Kann raus da das Uiframe sich jetzt selbst drum kümmert
            /////////////////////////////////////////////////////////
            //if (this.heading && this.title) {
            //    //this.hideNode(this.heading, false)
            //    //this.heading.innerHTML = this.title;
            //} else {
            //    //console.error("Heading missing in template");
            //}

            this.currentDisplayMode = "node";
            this.isActive = true;
            this._continueShow();
        }
        

    }

    expand(bExpand: boolean = true, forceState?: boolean) {
        if (this.currentDisplayMode == "expander") {
            this._uiFrameExpandableSection.toggleExpand(bExpand, forceState);
        }
    }

    private _onExpandSection(expanded: boolean) {
        if (this.currentDisplayMode == "expander") {
            if (typeof this.onExpand == "function") this.onExpand(expanded);

            expanded = this._uiFrameExpandableSection.isExpanded();
            this.emit(expanded ? "expand" : "collapse");
            this.emit("expanded", expanded);
        }
    }
    protected onExpand(bExpanded: boolean) {

    }

    //placeAt(node: any, position?: string | number): any {
    //    let self: any = this;
    //    self.inherited(arguments);

    //    this.show("node", this.title, this.tabContainerName, node);

    //    return this;
    //}
    //setup(config: EnityFrameOptons<X>, heading?: string, entityId?: string) {


    protected tryMoveToTab(bHandleOverflow = true): boolean {
        this._moveToTab(bHandleOverflow);

        return this.isEmbeddedInTab;
    }
    private _moveToTab(bHandleOverflow = true) {
        if (this.currentDisplayMode == "dlg" && this._uiFrameDlg) {
            //this._uiFrameDlg.destroyOnClose = false;

            this.show("tab", this.title, this.tabContainerName);
        }
    }
    protected _uiFrame_TopContainer: HTMLElement;
    protected _uiFrame_BottomContainer: HTMLElement;
    protected _uiFrame_Heading: HTMLElement;
    protected _uiFrame_ActionBar: HTMLElement;

    private _destroyFrameContainer() {
        if (this._uiFrame_TopContainer) {
            this.UiModder.domConstruct.destroy(this._uiFrame_TopContainer);
        }
        if (this._uiFrame_BottomContainer) {
            this.UiModder.domConstruct.destroy(this._uiFrame_BottomContainer);
        }

        this._uiFrame_BottomContainer = null;
        this._uiFrame_TopContainer = null;
    }
    protected _createFrameHeading(heading: string) {
        if (this._uiFrame_Heading) this.UiModder.domConstruct.destroy(this._uiFrame_Heading);
        if (this._uiFrame_TopContainer) {
            this._uiFrame_Heading = this.UiModder.domConstruct.create("h4", { innerHTML: this.title, class: "uiFrameHeading" }, this._uiFrame_TopContainer, "first");
            this.hideNode(this._uiFrame_Heading, !this.title);
            this.hideNode(this._uiFrame_TopContainer, !this._uiFrameIsStandalone);
        }

    }
    protected _setupFrameContainers() {

        if (!this._uiFrameIsStandalone) return; // nicht standalone-uiframes müssen sich um ihre Buttoncontainers selber kümmern!
        if (!!this.buttonContainerPrimary) return; // wenn der uiframe schon buttoncontainers mitbringt, dann ebenfalls abbrechen

        this._destroyFrameContainer();

        this.UiModder.domClass.toggle(this.domNode, "standalone", this._uiFrameIsStandalone);
        this.UiModder.domClass.toggle(this.domNode, "displayFrame", this._uiFrameIsStandalone && this.useStandaloneFrame);
        if (!this._uiFrameIsStandalone) return;

        let topContainer = this.UiModder.domConstruct.create("div", { className: "w3-hide flex_col", id: "frameContainer_Top" }, this.domNode, "first");
        this._uiFrame_ActionBar = this.UiModder.domConstruct.create("div", { className: "flex_row justify_right flex_gapSmall", id: "frameActionbar" }, topContainer, "last");
        this.buttonContainerPrimary = this.UiModder.domConstruct.create("div", { className: "buttonGroup justify_right", id: "Primary" }, this._uiFrame_ActionBar, "first");
        this.buttonContainerSecondary = this.UiModder.domConstruct.create("div", { className: "buttonGroup", id: "buttonContainerSecondary" }, this._uiFrame_ActionBar, "last");

        let bottomContainer = this.UiModder.domConstruct.create("div", { className: "w3-hide", id: "frameContainer_Bottom" }, this.domNode, "last");
        this._uiFrame_TopContainer = topContainer;
        this._uiFrame_BottomContainer = bottomContainer;

        this._createFrameHeading(this.title);
        if (this.title) {            
            this.hideNode(topContainer, false);
        }


    }

    protected onShow() {
        // wird von Kindklasse überschrieben
    }

    protected onFirstStartup() {
        // wird von Kindklasse überschrieben
    }

    private _continueShow() {

        this._setupFrameContainers();

        let previouslyAddedButtons = this.__buttonConfigs;
        //let previouslyAddedDefaultButtons = this.default
        this.__buttonConfigs = [];
        this.__createdDefaultButtons = [];

        for (let entry of previouslyAddedButtons) {
            this.addButtonEx(entry);
        }

        let queue = this.__buttonConfigsQueue;
        this.__buttonConfigsQueue = [];
        for (let entry of queue) {
            this.addButtonEx(entry);
        }

        this.onShow();
        if (!this.__uiFrameStartupFinished) {
            this.onFirstStartup();
            this.__uiFrameStartupFinished = true;
        }

    }
    protected isFirstStartupFinished(): boolean {
        return this.__uiFrameStartupFinished;
    }

    private __uiFrameStartupFinished: boolean;


    // Tabcontainer-Mixin:
    protected _onActivated() {

    }

    protected onClose() {

    }

    close() {
        //if (!this.isActive) return;

        this.isActive = false;

        this.onClose();

        if (this.currentDisplayMode == "dlg" && this._uiFrameDlg && this._uiFrameDlg.is_active == true) {
            this._uiFrameDlg.close(-1);
            this._uiFrameDlg = null;
        } else if (this.currentDisplayMode == "tab") {
            if (TabbingHelpers.closeTab(this.internalName, this.tabContainerName) == true) {
                this._tabContainer = null;
            }
        } else if (this.currentDisplayMode == "expander" && this._uiFrameExpandableSection) {
            this._uiFrameExpandableSection.toggleExpand(false);
            if (this._destroyed) {

            }
        } else if (this.currentDisplayMode == "node") {
            //this.RequestManager.cancelRunningRequests();
        } else if (this.currentDisplayMode == "floatingContainer") {
            if (this._uiFrameFloatingContainer) {
                this._uiFrameFloatingContainer.close();
            }
        }

        this.emit("closed");
    }

    /**
     * Einen kontextbezogenen NEU-Button erstellen.
     * Label und Farbe werden ignoriert.
     * Die Konfiguration wird im Hintergrund so standardisiert, dass das Label gleichbleibend ist.
     * @param requestData Konfigurationsparameter inklusive Beschriftung und Callback
     * @param initialEnabledState
     */
    createDefaultButton(type: uiFrameTypes.DefaultButtonName, callback: Function,
        initialEnabledState: boolean = true, overridePlacement?: uiFrameTypes.ButtonPlacement, overrideLabel?: string) {


        //if (!this.isEmbeddedInTab) return;

        if (type == "deleteWithConfirmationDlg") {
            // dann packen wir das Callback in eine Standardmethode mit GenericDlg:
            let newCallback = lang.hitch(this, this._defaultDeleteCallbackDlg, callback, null);
            callback = newCallback;
            type = "delete";
        }

        if (type == "copy") type = "clone";

        if (this.__createdDefaultButtons.indexOf(type) != -1) return;


        let permanent = false;
        let label = "";
        let styleclass = null;
        let iconClass: string = "";
        let icon: HTMLElement = null;
        let placement: uiFrameTypes.ButtonPlacement = "secondary";
        let bCloseOnClick: boolean = false;
        let order = 99;
        switch (type) {
            case "new":
                permanent = false;
                iconClass = "fas fa-plus-circle";
                label = this.translate("General_CreateNew");
                order = 0;
                break;
            case "ok":
                permanent = false;
                label = this.translate("General_Label_BtnConfirm");
                placement = "primary";
                order = 5;
                styleclass = "primaryBG";
                break;
            case "send":
                permanent = false;
                iconClass = "fas fa-paper-plane";
                label = this.translate("General_Label_Send");
                placement = "primary";
                styleclass = "primaryBG";
                order = 8;
                break;

            case "save":
                permanent = false;
                iconClass = "fas fa-save";
                label = this.translate("General_Save");
                placement = "primary";
                order = 10;
                styleclass = !overrideLabel ? "primaryBG" : "secondaryBG";
                break;

            case "rollback":
                permanent = false;
                iconClass = "fas fa-undo";
                label = this.translate("General_Rollback");
                placement = "primary";
                order = 12;
                break;

            case "clone":
                //case "copy":
                permanent = false;
                iconClass = "fas fa-clone";
                label = this.translate("General_Copy");
                placement = "primary";
                bCloseOnClick = true;
                order = 15;
                break;
            case "delete":
                permanent = false;
                iconClass = "fas fa-trash warningTXT";
                label = this.translate("General_Delete");
                placement = "secondary";
                order = 999;
                break;
            case "reload":
                permanent = false;
                iconClass = "fas fa-sync";
                label = this.translate("General_Reload");
                placement = "primary";
                styleclass = "secondaryBG";
                order = 20;
                break;
            case "edit":
                permanent = false;
                iconClass = "fas fa-edit";
                label = this.translate("General_Edit");
                order = 30;
                placement = "primary";
                styleclass = "accentBG";

                bCloseOnClick = true;
                callback = lang.hitch(this, this._onClickEditButton, callback);

                break;
            case "rollback":
                permanent = false;
                iconClass = "fas fa-reply"
                label = this.translate("General_Rollback");
                order = 40;
                placement = "primary";
                break;
            case "deactivate":
                permanent = false;
                iconClass = "fas fa-power-off"
                label = this.translate("General_SetAsInactive");
                order = 998;
                // den anderen suchen und rauswerfen:
                this.requestContextButtonRemove("activate");
                break;
            case "activate":
                permanent = false;
                iconClass = "fas fa-power-off"
                label = this.translate("General_SetAsActive");
                order = 998;
                // den anderen suchen und rauswerfen:
                this.requestContextButtonRemove("deactivate");
                break;
            default:

                return;
                break;
        }

        if (overrideLabel) label = overrideLabel;
        if (overridePlacement) placement = overridePlacement;

        this.addButton(type, label, callback, label, styleclass, iconClass, bCloseOnClick, placement, initialEnabledState, order);

        this.__createdDefaultButtons.push(type);

        //this.requestContextButton(config)

    }

    removeButton(internalName: string) {

        if (this.currentDisplayMode === "node") {

        }


        if (this._uiFrameIsStandalone) {
            //this.removeButton(internalName);
        }



        if (this._uiFrameDlg && !this._uiFrameDlg._destroyed) {
            this._uiFrameDlg.removeButton(
                internalName
            );
        }

        if (this.isEmbeddedInTab && this._tabContainer) {
            this._tabContainer.removeButton(internalName, this.internalName);
        }

        if (this._uiFrameIsStandalone) {
            let cfgIndex = this.getIndexOfButtonRegistry(internalName);
            if (cfgIndex != -1) {
                let cfg = this.__buttonConfigs[cfgIndex];
                if (cfg.button) {
                    this.UiModder.domConstruct.destroy(cfg.button.domNode);
                }
                cfg.button = null;
            }
        }

        // eigene Registrierung auch noch löschen
        let cfgIndex = this.getIndexOfButtonRegistry(internalName);
        while (cfgIndex != -1) {
            this.__buttonConfigs.splice(cfgIndex, 1);

            cfgIndex = this.getIndexOfButtonRegistry(internalName);
        }

        if (this._uiFrameIsStandalone) {
            this._updateMenuEntries();
            this._handleContainerVisibility();
        }
    }

    private _handleContainerVisibility() {
        if (this._uiFrameIsStandalone) {
            if (!this._hasButtonType("secondary")) {
                if (this.__secondaryButtonMenu) this.UiModder.domConstruct.destroy(this.__secondaryButtonMenu.domNode);
                this.__secondaryButtonMenu = null;
            }
            this.hideNode(this.buttonContainerPrimary, !this._hasButtonType("primary"));

            if (!this._hasButtonType("primary") && !this._hasButtonType("secondary")) {
                this.hideNode(this._uiFrame_ActionBar, true);
            } else {
                this.hideNode(this._uiFrame_ActionBar, false);
            }
        }
    }

    disableButton(internalName: string) {
        this.enableButton(internalName, false);
    }
    enableButton(internalName: string, bEnable: boolean = true): boolean {

        switch (this.currentDisplayMode) {
            case "dlg":
                if (this._uiFrameDlg && !this._uiFrameDlg._destroyed) {
                    this._uiFrameDlg.enableButton(internalName, bEnable);
                }
                break;

            case "tab":
                if (this.isEmbeddedInTab) {
                    TabbingHelpers.enableButton(internalName, this.internalName, this.tabContainerName, bEnable);
                }
                if (this._tabContainer) {
                    this._tabContainer.enableButton(internalName, null, bEnable);
                }
                break;

            case "expander":
                this._uiFrameExpandableSection.enableButton(internalName, bEnable);
                break;
            
            case "node":
            case "floatingContainer":
                
                if (this._uiFrameIsStandalone) {
                    let index = this.getIndexOfButtonRegistry(internalName);
                    if (index < 0) return;
                    let cfg = this.__buttonConfigs[index];
                    cfg.enabled = bEnable;
                    cfg?.button?.setReadonly(!bEnable);
                    //this.disableNode(button.node, !bEnable);
                }
                break;

            default: return false;
        }


        // in der eigenen registry auch noch aktualisieren, falls Anzeigemodus mal wechselt und die Buttons neu gezeichnet werden!
        let cfgIndex = this.getIndexOfButtonRegistry(internalName);
        if (cfgIndex != -1) {
            let cfg = this.__buttonConfigs[cfgIndex];
            cfg.enabled = bEnable !== false;
        }
        return true;
    }
    addButton(
        internalName: string,
        label: string,
        callback: Function,
        tooltip?: string,
        styleClass?: string,
        iconClass?: string,
        bCloseOnClick?: boolean,
        position?: "primary" | "secondary",
        enabled?: boolean,
        order?: number,

    ) {
        let i = this.getIndexOfButtonQueue(internalName);
        if (i != -1) this.__buttonConfigsQueue.splice(i, 1);

        //let iB = this.getIndexOfButtonRegistry(internalName);
        //if (iB != -1) {
        //    this._buttonConfigs.splice(iB, 1);
        //}

        if (order == null || order == undefined) {
            order = this.__buttonConfigs.length;
        }

        let buttonConfig: uiFrameTypes.ButtonConfig = {
            internalName: internalName,
            callback: callback,
            label: label,
            tooltip: tooltip,
            bCloseOnClick: bCloseOnClick,
            enabled: enabled,
            iconClass: iconClass,
            position: position,
            order: order,
            styleClass: styleClass
        };

        this._createContextButton(buttonConfig);
    }
    //addButton_Config(buttonConfig: uiFrameTypes.ButtonConfig) {
    //    this._createContextButton(buttonConfig);
    //}

    addButtonEx(buttonConfig: uiFrameTypes.ButtonConfig) {
        this._createContextButton(buttonConfig);
    }

    private _createContextButton(buttonConfig: uiFrameTypes.ButtonConfig) {
        if (this.currentDisplayMode === "node" || this._uiFrameIsStandalone) this.removeButton(buttonConfig.internalName);
        this.__buttonConfigs.push(buttonConfig);
        if (this.currentDisplayMode == "expander") {
            this._uiFrameExpandableSection.addButtonToExpander(
                buttonConfig.internalName,
                buttonConfig.callback,
                buttonConfig.iconClass,
                buttonConfig.label,
                buttonConfig.styleClass,
                buttonConfig.position == "secondary" ? "left" : "right",
                buttonConfig.enabled !== false);
        }
        else if (this.currentDisplayMode === "node" || this._uiFrameIsStandalone) {
            if (!buttonConfig.position) buttonConfig.position = "primary"; // <--- default fallback
            if (buttonConfig.position === "primary" && this.buttonContainerPrimary) {
                let button = new Button();
                button.setup({
                    label: buttonConfig.label,
                    iconClass: buttonConfig.iconClass,
                    callback: lang.hitch(this, this._onClickContextButton, buttonConfig),
                    parentNode: this.buttonContainerPrimary,
                    styleClass: buttonConfig.styleClass
                });
                buttonConfig.button = button;
                button.setReadonly(true);

                //let button = this.UiModder.domConstruct.create(
                //    "button",
                //    {
                //        "innerHTML": this.canTranslate(buttonConfig.label) ? this.translate(buttonConfig.label) : buttonConfig.label,
                //        "className": " buttonBase hoverAuto w3-disabled"
                //    },
                //    this.buttonContainerPrimary,
                //    buttonConfig.order);
                //buttonConfig.node = button;

                //if (buttonConfig.styleClass) {
                //    this.UiModder.domClass.add(button, buttonConfig.styleClass);
                //}

                //if (buttonConfig.iconClass) {
                //    let icon = this.UiModder.domConstruct.create("i", { "className": "marginSmallRight" }, button, "first");
                //    this.UiModder.domClass.add(icon, buttonConfig.iconClass);
                //}

                //on(button, "click", lang.hitch(this, this._onClickContextButton, buttonConfig));

                this.enableButton(buttonConfig.internalName, buttonConfig.enabled && typeof (buttonConfig.callback) == "function");
            } else if (buttonConfig.position === "secondary" && this.buttonContainerSecondary) {
                if (!this.__secondaryButtonMenu) {
                    //this.secondaryButtonMenu = this.UiModder.domConstruct.create("button", { "className": "buttonBase hoverAuto primaryBG" }, this.buttonContainerSecondary);
                    this.__secondaryButtonMenu = new Button();
                    this.__secondaryButtonMenu.setup({
                        styleClass: "primaryBG",
                        callback: lang.hitch(this, this._onClickSecondaryButtonMenu),
                        iconClass: "fas fa-ellipsis-h",
                        parentNode: this.buttonContainerSecondary
                    });

                    //this.UiModder.domConstruct.create("button", { "className": "buttonBase hoverAuto primaryBG" }, this.buttonContainerSecondary);
                    //this.UiModder.domConstruct.create("i", { "className": "fas fa-ellipsis-h" }, this.secondaryButtonMenu);
                    //on(this.secondaryButtonMenu, "click", lang.hitch(this, this._onClickSecondaryButtonMenu));

                } else {
                    this._updateMenuEntries();
                }
            } else {
                console.error("Missing primary button container");
            }
            this.hideNode(this._uiFrame_TopContainer, this.__buttonConfigs.length == 0);

            //Kommt hier derzeit nicht hin wird am Fall drüber abgefangen
        } else if (this._uiFrameIsStandalone) {

            let button = new Button();
            button.setup({
                label: buttonConfig.label,
                iconClass: buttonConfig.iconClass,
                callback: lang.hitch(this, this._onClickContextButton, buttonConfig),
                parentNode: this._uiFrame_ActionBar,
                styleClass: "contextButton"
            });
            buttonConfig.button = button;
            button.setReadonly(true);

            //let button = this.UiModder.domConstruct.create("button", {
            //    "innerHTML": buttonConfig.label,
            //    "className": "contextButton buttonBase hoverBright w3-disabled"
            //}, this.frame_ActionBar,
            //    buttonConfig.position == "primary" ? buttonConfig.position : "secondary");

            //buttonConfig.node = button;

            //if (buttonConfig.styleClass) this.UiModder.domClass.add(button, buttonConfig.styleClass);
            //if (buttonConfig.iconClass) {
            //    let icon = this.createFontawesomeIcon(buttonConfig.iconClass);
            //    this.UiModder.domConstruct.place(icon, button, "first");
            //}

            //on(button, "click", lang.hitch(this, this._onClickContextButton, buttonConfig))

            this.enableButton(buttonConfig.internalName, buttonConfig.enabled && typeof (buttonConfig.callback) == "function");

            this.hideNode(this._uiFrame_ActionBar, this.__buttonConfigs.length == 0);
            //Check for DLG first. Could be Dlg but embedded in tab
        } else if (this._uiFrameDlg && !this._uiFrameDlg._destroyed) {
            this._uiFrameDlg.addButtonEx({
                internalName: buttonConfig.internalName,
                label: buttonConfig.label,
                callback: buttonConfig.callback,
                tooltip: buttonConfig.tooltip,
                styleClass: buttonConfig.styleClass,
                iconClass: buttonConfig.iconClass,
                bCloseOnClick: buttonConfig.bCloseOnClick === true,
                placement: buttonConfig.position == "primary" ? "last" : "left first",
                enabled: buttonConfig.enabled,
                order: buttonConfig.order,
                groupname: buttonConfig.groupname,
                hasNextLevel: buttonConfig.hasNextLevel,
                hasPreviousLevel: buttonConfig.hasPreviousLevel
            }
            );

        } else if (this.isEmbeddedInTab) {

            let tabbingConfig: Tabbing.ContextActionButtonRequest =
            {
                callback: buttonConfig.callback,
                label: buttonConfig.label,
                name: buttonConfig.internalName,
                iconClass: buttonConfig.iconClass,
                heading: null,
                permanent: false,
                enabled: buttonConfig.enabled,
                coloration: null,//buttonConfig.co,
                order: buttonConfig.order,
                styleClass: buttonConfig.styleClass,
                placement: buttonConfig.position == "primary" ? "actionbar" : "primarymenu",
                groupName: buttonConfig.groupname,
                tooltip: buttonConfig.tooltip
            };

            // defaultbutton rauszupfen, falls die von uiframe o.ä. übergeben wurden wie ein normaler Button
            switch (tabbingConfig?.name as Tabbing.DefaultButtonName) {
                case "save":
                case "send":
                case "submit":
                case "reload":
                case "rollback":
                case "clone":
                case "deactivate":
                case "activate":
                case "delete":
                case "deleteWithConfirmationDlg":
                case "edit":
                case "new":
                    tabbingConfig.isDefault = true;
                    break;


            }

            this.emit("requestNewContextButton", tabbingConfig);

            // nochmal in die Hoverleiste platzieren, falls additionalPosition ausgefüllt.
            if (buttonConfig.additionalPosition == "primary") {
                tabbingConfig.placement = "bottombar";
                this.emit("requestNewContextButton", tabbingConfig);

            }


        } else if (this._uiFrameDlg && !this._uiFrameDlg._destroyed) {
            this._uiFrameDlg.addButtonEx({
                internalName: buttonConfig.internalName,
                label: buttonConfig.label,
                callback: buttonConfig.callback,
                tooltip: buttonConfig.tooltip,
                styleClass: buttonConfig.styleClass,
                iconClass: buttonConfig.iconClass,
                bCloseOnClick: buttonConfig.bCloseOnClick,
                placement: buttonConfig.position == "primary" ? "first" : "left first",
                enabled: buttonConfig.enabled,
                order: buttonConfig.order,
                groupname: buttonConfig.groupname,
                hasNextLevel: buttonConfig.hasNextLevel,
                hasPreviousLevel: buttonConfig.hasPreviousLevel
            });
        } else {
            this.__buttonConfigsQueue.push({
                callback: buttonConfig.callback,
                internalName: buttonConfig.internalName,
                label: buttonConfig.label,
                bCloseOnClick: buttonConfig.bCloseOnClick,
                enabled: buttonConfig.enabled,
                iconClass: buttonConfig.iconClass,
                position: buttonConfig.position,
                styleClass: buttonConfig.styleClass,
                tooltip: buttonConfig.tooltip,
                order: buttonConfig.order
            });
        }

        this._handleContainerVisibility();
    }

    addButtonMenuEx(buttonMenuConfig: uiFrameTypes.ButtonGroupConfig) {
        this._createContextButtonMenu(buttonMenuConfig);
    }

    private _createContextButtonMenu(buttonMenuConfig: uiFrameTypes.ButtonGroupConfig) {

        if (this._uiFrameDlg && !this._uiFrameDlg._destroyed) {
            this._uiFrameDlg.addButtonMenu(
                buttonMenuConfig.internalName,
                buttonMenuConfig.label,
                buttonMenuConfig.iconClass,
                buttonMenuConfig.bIsGroupNextLevel,
                buttonMenuConfig.parentGroupName
            );

        } else if (this.isEmbeddedInTab) {
            let tabMenuGroupConfig: Tabbing.PrimaryMenuGroupRequest = {
                label: buttonMenuConfig.label,
                name: buttonMenuConfig.internalName,
                hasNextLevel: buttonMenuConfig.bIsGroupNextLevel,
                iconClass: buttonMenuConfig.iconClass,
                parentGroupName: buttonMenuConfig.parentGroupName
            }

            this.emit("requestNewMenuGroup", tabMenuGroupConfig);
        } else if (this.currentDisplayMode === "node" || this._uiFrameIsStandalone) {
            this.__buttonMenuConfigs.push(buttonMenuConfig);
            this._updateMenuEntries();
        }

        this._handleContainerVisibility();
    }

    private _onClickContextButton(config: EntityViewTypes.ButtonConfig, evt: MouseEvent) {
        if (!config?.enabled) return;
        if (config.callback) config.callback();
    }

    private _hasButtonType(type: "primary" | "secondary"): boolean {
        for (let entry of this.__buttonConfigs) {
            if (entry.position === type) return true;
        }
        return false;
    }

    private _onClickSecondaryButtonMenu(evt: MouseEvent) {

        if (!this._hasButtonType("secondary")) return;


        this.__secondaryButtonFloatingMenu = new FloatingMenu();

        for (let entry of this.__buttonMenuConfigs) {
            this.__secondaryButtonFloatingMenu.addGroup(
                entry.internalName,
                entry.label,
                entry.iconClass,
                entry.bIsGroupNextLevel,
                entry.parentGroupName
            );
        }

        for (let entry of this.__buttonConfigs) {
            if (entry.position === "secondary") {
                let node = this.__secondaryButtonFloatingMenu.addEntry({
                    callback: lang.hitch(this, entry.callback),
                    label: entry.label,
                    name: entry.internalName,
                    enabled: entry.enabled,
                    order: entry.order,
                    icon: entry.iconClass,
                    groupname: entry.groupname,
                    hasNextLevel: entry.hasNextLevel,
                    hasPreviousLevel: entry.hasPreviousLevel,
                    coloration: entry.styleClass,
                    tooltipConfig: { content: entry.tooltip }
                });
                //entry.node = node;
            }
        }

        if (evt) this.__secondaryButtonFloatingMenu.open(evt);
    }

    private _updateMenuEntries() {
        if (this.__secondaryButtonFloatingMenu && !this.__secondaryButtonFloatingMenu._destroyed) {
            this.__secondaryButtonFloatingMenu.clearEntries();
        } else {
            return;
        }

        for (let entry of this.__buttonMenuConfigs) {
            this.__secondaryButtonFloatingMenu.addGroup(
                entry.internalName,
                entry.label,
                entry.iconClass,
                entry.bIsGroupNextLevel,
                entry.parentGroupName
            );
        }

        for (let entry of this.__buttonConfigs) {
            if (entry.position === "secondary") {
                let node = this.__secondaryButtonFloatingMenu.addEntry({
                    callback: lang.hitch(this, entry.callback),
                    label: entry.label,
                    name: entry.internalName,
                    enabled: entry.enabled,
                    order: entry.order,
                    icon: entry.iconClass,
                    groupname: entry.groupname,
                    hasNextLevel: entry.hasNextLevel,
                    hasPreviousLevel: entry.hasPreviousLevel,
                    coloration: entry.styleClass,
                    tooltipConfig: { content: entry.tooltip }
                });
                //entry.node = node;
            }
        }
    }

    protected _onClickEditButton(realCallback: Function) {
        this.emit("requestRemoveContextButton", "edit");
        realCallback();
    }


    protected _defaultDeleteCallbackDlg(actualCallback: Function, dlgResult: number = null) {
        // beim Klick auf Delete kommen wir mit result NULL hierher:

        if (dlgResult == null) {
            let dlg = new GenericDialog();
            dlg.show("General_ConfirmDeleteMessage",
                this.translate("General_Delete") + " - " + this.title,
                null,
                "fas fa-trash",
                "yesno",
                lang.hitch(this, this._defaultDeleteCallbackDlg, actualCallback)
            );
            return;
            //dojoRequire(["moreCore/UI/GenericDialog/GenericDialog"],
            //    lang.hitch(this, this._isolatedDeleteDlg, actualCallback) as dojo.GenericFunction<void>);

            return;
        } else { // nach dem Dlg kommen wir mit einem Result hierher und können abbrechen oder das eigentliche Callback ausführen:
            if (dlgResult <= 0) {
                return;
            } else {
                actualCallback();
            }
        }
    }

    private _isolatedDeleteDlg(actualCallback, GenericDialog) {
        let dlg = new GenericDialog();
        dlg.show("General_ConfirmDeleteMessage",
            this.translate("General_Delete") + " - " + this.title,
            null,
            "fas fa-trash",
            "yesno",
            lang.hitch(this, this._defaultDeleteCallbackDlg, actualCallback)
        );
    }

    protected getIndexOfButtonQueue(buttonName: string) {
        let index = -1;
        for (let entry of this.__buttonConfigsQueue) {
            index++;
            if (entry.internalName == buttonName) {
                return index;
            }
        }

        return -1;
    }
    protected getIndexOfButtonRegistry(buttonName: string) {
        let index = -1;
        for (let entry of this.__buttonConfigs) {
            index++;
            if (entry.internalName == buttonName) {
                return index;
            }
        }

        return -1;
    }

    private _onEmbedding(page, tabcontainername) {
        // wir sind ja eigentlich kein tabenabled-Mixin. aber wenn ein anderes Widget uns als Tab einbinden möchte, dann versucht der Container das onEmbedding aufzurufen:
        this._continueShow(); // das war mal auskommentiert. Grund unbekannt. Bitte um Info wenn da was spießt - RJ, 2026-01-27
    }

    private _setTitleAttr(title: string) {
        this.setTitles(title);
    }

    setTitles(mainTitle?: string, topBarTitle?: string) {

        // Hinweis: Leerstring "" zulassen. nur undefined und null sollen als "ich will einen Ersatzwert" gelten
        let title = topBarTitle;
        if (!topBarTitle) {
            mainTitle = TranslationHelpers.tryTranslate(mainTitle);
            title = mainTitle;
        }

        if (typeof (title) != "undefined") {
            topBarTitle = TranslationHelpers.tryTranslate(topBarTitle);
            this.title = topBarTitle;
        }

        if (!this.title && !!title) this.title = title;

        //if (!this.title) debugger;

        if (this.isEmbeddedInTab) {
            TabbingHelpers.requestTabTitleRename(this.internalName, this.title);
            // if (iconClass)  // TODO setter für Tabicon!
        }
        if (this.currentDisplayMode == "dlg") {
            this._uiFrameDlg._setHeaderAttr(this.title);
            //if (iconClass != undefined) this._uiFrameDlg._setTextIconAttr(iconClass);
        }

        if (this.currentDisplayMode === "node") {
            if (this._uiFrame_Heading) this._uiFrame_Heading.innerHTML = this.title;
        }

        if (this._uiFrameIsStandalone) {
            if (this._uiFrame_Heading) this._uiFrame_Heading.innerHTML = this.title;
            this.hideNode(this._uiFrame_Heading, !this.title);
        }

    }

    postCreate(): void {
        let self: any = this;
        super.postCreate.apply(this, arguments as any);

        this.__buttonConfigsQueue = [];
        this.__buttonConfigs = [];
        this.__buttonMenuConfigs = [];
        this.__createdDefaultButtons = [];


        this.useStandbyManager = true;

        if (this.heading) this.hideNode(this.heading, true);
    }

    startup(): void {
        // required for dojo inheritance to call the superclass

        let self: any = this;
        super.startup.apply(this, arguments as any);

    }
}

;
Object.assign(__C.prototype, {
  _uiFrameDlg: null,
  _tabContainer: null,
  isEmbeddedInTab: false,
  _uiFrameIsStandalone: false,
  useStandaloneFrame: false,
  _uiFrameExpandableSection: null,
  internalName: null,
  tabContainerName: null,
  isActive: false,
  currentDisplayMode: null,
  __buttonConfigsQueue: null,
  __buttonConfigs: null,
  __buttonMenuConfigs: null,
  __createdDefaultButtons: [],
  _isEmptyContent: true,
  __hideIfEmpty: true,
  __isHidden: false,
  __hidingCallback: null,
  __uiFrameStartupFinished: false,
  declaredClass: '_uiFrameMixin',
});
  return __C;
}
Object.assign(_uiFrameMixin, { __mdsMixinFactory: true, __mdsSpineBases: [_WidgetBaseSP] });
